import React from "react";

const DocusignIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6 0H2.4C1.07452 0 0 1.07452 0 2.4V13.6C0 14.9255 1.07452 16 2.4 16H13.6C14.9255 16 16 14.9255 16 13.6V2.4C16 1.07452 14.9255 0 13.6 0Z",
  fill: "#D5FF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7525 12.2159H2.22595V13.767H13.7525V12.2159Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99137 11.3275L9.08886 10.2321L12.4252 6.89372L11.3151 5.78579L8.76691 8.3361V2.01678H7.21376L7.21582 8.3361L4.66555 5.78579L3.55762 6.89372L6.89392 10.2321L7.99137 11.3275Z",
  fill: "black"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DocusignIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;